import { render, staticRenderFns } from "./ViewSchedules.vue?vue&type=template&id=4d80c2c6&scoped=true&"
import script from "./ViewSchedules.vue?vue&type=script&lang=ts&"
export * from "./ViewSchedules.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSchedules.vue?vue&type=style&index=0&id=4d80c2c6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80c2c6",
  null
  
)

export default component.exports